

















import { Component, Mixins } from "vue-property-decorator";
import { Point } from "../../domain/drawing";
import { ClipboardUtility, IClipboardAccessible } from "../../utilities";

@Component
export default class TextInputContextMenu extends Mixins() {
  data(): any {
    return {
      accessor: ClipboardUtility.createAccessor(),
      location: null,
      target: null,
      pasteText: "",
    };
  }
  accessor: IClipboardAccessible;
  location: Point;
  target: HTMLInputElement | HTMLTextAreaElement;
  pasteText: string;

  get geometryProperties(): any {
    return !!this.location
      ? {
        top: this.location.y + "px",
        left: this.location.x + "px",
        zIndex: this.getZIndex(),
      }
      : null;
  }

  private getZIndex(): number {
    // el-dialogのz-indexは表示毎に採番し直しているため算出する
    const elements = document.querySelectorAll("*[style*='z-index']");
    const length = elements.length;
    const items = [];
    for (let i = 0; i < length; i++) {
      const zIndex = parseInt((elements[i] as HTMLElement).style.zIndex, 10);
      if (isNaN(zIndex)) {
        continue;
      }
      items.push(zIndex);
    }
    return items.length > 0
      ? Math.max(...items) + 1
      : undefined;
  }

  get shouldShow(): boolean {
     return !!this.location;
  }

  get isCuttable(): boolean {
    return !!this.target && this.target.selectionStart < this.target.selectionEnd;
  }

  get isCopyable(): boolean {
    return !!this.target && this.target.selectionStart < this.target.selectionEnd;
  }

  get isPastable(): boolean {
    return !!this.target && this.pasteText !== "";
  }

  show(event: PointerEvent): void {
    if (!(event.target instanceof HTMLInputElement) && !(event.target instanceof HTMLTextAreaElement)) {
      return;
    }
    window.addEventListener("click", this.hide);
    window.addEventListener("scroll", this.hide, true);
    this.location = new Point(event.clientX, event.clientY);
    this.target = event.target;
    this.accessor.readText().then(v => this.pasteText = v);
  }

  private hide(): void {
    window.removeEventListener("click", this.hide);
    window.removeEventListener("scroll", this.hide, true);
    this.location = null;
    this.target = null;
    this.pasteText = "";
  }

  copy(): void {
    this.target.focus();
    document.execCommand("copy");
  }

  paste(): void {
    const index = this.target.selectionStart + this.pasteText.replace(/\n/g, "").length;
    this.target.focus();
    this.target.value = this.target.value.slice(0, this.target.selectionStart) + this.pasteText + this.target.value.slice(this.target.selectionEnd);
    this.target.selectionStart = index;
    this.target.selectionEnd = index;
    // Vueのv-modelを更新するためにイベントを発行する
    const inputEvent = document.createEvent("Event");
    inputEvent.initEvent("input", true, false);
    this.target.dispatchEvent(inputEvent);
    const changeEvent = document.createEvent("Event");
    changeEvent.initEvent("change", true, false);
    this.target.dispatchEvent(changeEvent);
  }

  cut(): void {
    this.target.focus();
    document.execCommand("cut");
  }
}
